/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TextCustomField
 */
export interface TextCustomField {
    /**
     * The unique identifier of the text custom field
     * @type {string}
     * @memberof TextCustomField
     */
    fieldId?: string;
    /**
     * The name of the text custom field
     * @type {string}
     * @memberof TextCustomField
     */
    name?: string;
    /**
     * Indicates whether the field is required to be completed by the sender
     * @type {string}
     * @memberof TextCustomField
     */
    required?: string;
    /**
     * Indicates whether the text field should be displayed in the signing request
     * @type {string}
     * @memberof TextCustomField
     */
    show?: string;
    /**
     * The value assigned to the text custom field
     * @type {string}
     * @memberof TextCustomField
     */
    value?: string;
}

/**
 * Check if a given object implements the TextCustomField interface.
 */
export function instanceOfTextCustomField(value: object): boolean {
    return true;
}

export function TextCustomFieldFromJSON(json: any): TextCustomField {
    return TextCustomFieldFromJSONTyped(json, false);
}

export function TextCustomFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): TextCustomField {
    if (json == null) {
        return json;
    }
    return {
        
        'fieldId': json['fieldId'] == null ? undefined : json['fieldId'],
        'name': json['name'] == null ? undefined : json['name'],
        'required': json['required'] == null ? undefined : json['required'],
        'show': json['show'] == null ? undefined : json['show'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function TextCustomFieldToJSON(value?: TextCustomField | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fieldId': value['fieldId'],
        'name': value['name'],
        'required': value['required'],
        'show': value['show'],
        'value': value['value'],
    };
}

